import React from 'react';
import styled from 'styled-components';
import { Footer } from 'hui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onLoginCheckSuccess } from '../actions/user';
import AppErrorBoundary from '../components/AppErrorBoundary';
import ErrorBoundary from '../components/ErrorBoundary';
import qs from 'query-string';
import { State } from '../reducers';
import Header from '@hipagesgroup/header';
import withLogin from '@hipagesgroup/with-login';
// TODO More this to HUI - Flexbox? @joeruello
const Main = styled.main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const Holder = () => <span />;

const LoginCheck = withLogin(Holder);

type Props = ReturnType<typeof stateToProps> &
  typeof dispatchToProps & { children: React.ReactNode };

const StandardLayout = ({ isAppOnly, children, onLoginCheckSuccess }: Props) => {
  return (
    <>
      <ErrorBoundary name={`Header`} style={{ height: 69, background: '#fff', width: '100vw' }}>
        {isAppOnly ? (
          <LoginCheck loginDataHandle={onLoginCheckSuccess} />
        ) : (
          <Header siteSource={''} loginDataHandle={onLoginCheckSuccess} />
        )}
      </ErrorBoundary>
      <AppErrorBoundary>
        <Main>{children}</Main>
      </AppErrorBoundary>
      {!isAppOnly && <Footer />}
    </>
  );
};

StandardLayout.propTypes = {
  isAppOnly: PropTypes.bool,
  children: PropTypes.node,
  location: PropTypes.object,
  onLoginCheckSuccess: PropTypes.func
};

const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

const getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const stateToProps = (state: State) => {
  const query = qs.parse(state.router.location.search);
  const isAppOnly = !!query.app_only;
  if (isAppOnly) {
    if (typeof window !== 'undefined') {
      setCookie('isAppOnly', 'true', 1);
    }
    return {
      isAppOnly
    };
  }
  let set = false;
  if (typeof window !== 'undefined') {
    const isAppView = getCookie('isAppOnly');
    set = isAppView === 'true' ? true : false;
  }
  return { isAppOnly: set };
};

const dispatchToProps = { onLoginCheckSuccess };

export default connect(
  stateToProps,
  dispatchToProps
)(StandardLayout);
